import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaFire, FaStore, FaUser } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from './LoginModal';
import './Navbar.css';

function Navbar() {
    const [showLoginModal, setShowLoginModal] = useState(false);
    const { user, logout } = useAuth();
  
    const handleLogout = async () => {
      try {
        await logout();
        // Optionally redirect to home page
      } catch (error) {
        console.error('Failed to log out:', error);
      }
    };
  
    return (
      <>
        <nav className="navbar">
          <div className="nav-left">
            <Link to="/" className="nav-item">
              <FaHome /> Home
            </Link>
            <Link to="/trending" className="nav-item">
              <FaFire /> Trending
            </Link>
            <Link to="/store" className="nav-item">
              <FaStore /> Store
            </Link>
          </div>
          <div className="nav-right">
            {user ? (
              <>
                <Link to="/profile" className="nav-item">
                  <FaUser /> Profile
                </Link>
                <button onClick={handleLogout} className="nav-item logout-button">
                  Logout
                </button>
              </>
            ) : (
              <button onClick={() => setShowLoginModal(true)} className="nav-item">
                <FaUser /> Login
              </button>
            )}
          </div>
        </nav>
        
        {/* Add the LoginModal component */}
        <LoginModal 
          isOpen={showLoginModal} 
          onClose={() => setShowLoginModal(false)} 
        />
      </>
    );
  }

export default Navbar;